import React from "react";
import { Switch, Route } from "react-router-dom";
import TermosViews from "views/termos-views";

export const TermosLayout = () => {
	return (
		<div className="auth-container">
			<Switch>
				<Route path="" component={TermosViews} />
			</Switch>
		</div>
	);
};

export default TermosLayout;
